import { useState } from "react";

import { Container, Content, IconClose } from "./styles";

import CloseIcon from "../../../assets/images/icons/close.svg";

const Slide = ({ images, showAlbum, setShowAlbum }) => {
  const [index, setIndex] = useState(0);

  const close = () => {
    setIndex(0);
    setShowAlbum(false);
  };

  return (
    <Container style={{ display: showAlbum ? "flex" : "none" }}>
      <Content>
        <IconClose src={CloseIcon} onClick={() => close()} />
        <button
          onClick={() =>
            setIndex((currentIndex) =>
              currentIndex === 0 ? images.length - 1 : currentIndex - 1
            )
          }
        >
          {"<"}
        </button>
        <div>
          <img src={images[index].image} alt="imagem" />
        </div>
        <button
          onClick={() =>
            setIndex((currentIndex) =>
              currentIndex === images.length - 1 ? 0 : currentIndex + 1
            )
          }
        >
          {">"}
        </button>
      </Content>
    </Container>
  );
};

export default Slide;
